import { postsByCategory } from '../api'
import blog from '../blog'
import search from '../search'
import { prognosticHtml } from '../prognostics/prognostic-markup'

const morePost = {
  handleClick: ({ id, offset, pageCurrent, typePost, layout, searchQuery, fields }) => {
    let button = document.querySelector('.CardPostWrapper-btn')
    let container = document.querySelector('.CardPostSection-list')

    switch (layout) {
      case 'prognostico': {
        button = document.querySelector('.CardPrognosticWrapper-btn')
        container = document.querySelector('.CardPrognosticSection-list')
        break
      }
      case 'search': {
        button = document.querySelector('.CardSearchWrapper-btn')
        container = document.querySelector('.Search-features')
        break
      }
    }

    if (button) {
      button.addEventListener('click', async event => {
        event.preventDefault()
        const url = new URL(window.location)

        id = url.searchParams.get('category') || document.querySelector('#categoryShowPostBlock')
             ? document.querySelector('#categoryShowPostBlock').value
             : document.querySelector('#categoryShowPrognosticBlock')
             ? document.querySelector('#categoryShowPrognosticBlock').value
             : false || 0
        pageCurrent = url.searchParams.get('pagina') || 0

        pageCurrent++
        offset = pageCurrent * 12 - 12

        morePost.toggleLoading(container)

        const filterDateActive = document.querySelector('.prognostics-filter-date__list-item.--is-active')
        const { data, totalPages } = await postsByCategory({
          filterDate: filterDateActive ? filterDateActive.dataset.filterDate || 'all' : 'all',
          id,
          offset,
          pageCurrent,
          perPage: 12,
          postType: typePost,
          search: searchQuery,
          fields
        })

        const posts = await data

        let el = document.createRange().createContextualFragment(blog.markup({ data: posts }))
        if (layout === 'prognostico') {
          el = document.createRange().createContextualFragment(await prognosticHtml.render({ data: posts }))
        } else if (layout === 'search') {
          el = document.createRange().createContextualFragment(search.markup({ data: posts }))
        }

        const beforePosition = window.scrollY || document.documentElement.scrollTop;

        container.append(el)

        const currentPosition = window.scrollY || document.documentElement.scrollTop;

        morePost.toggleLoading(container)


        window.scrollBy({
          left: 0,
          top: `-${currentPosition - beforePosition}`
        })

        // Atualiza a URL no navegador
        url.searchParams.set('pagina', pageCurrent)
        window.history.pushState({}, '', url)

        // Atualiza o link do botão "Carregar mais"
        url.searchParams.set('pagina', pageCurrent + 1)
        event.target.setAttribute('href', url.toString())

        if (totalPages === pageCurrent) {
          button.style.display = 'none'
        }
      })
    }
  },

  init: ({ id, pageCurrent, offset, typePost, layout, searchQuery, fields = false }) => {
    morePost.handleClick({ id, pageCurrent, offset, typePost, layout, searchQuery, fields })
  },

  toggleLoading: (container) => {
    const loaderContainer = container.parentElement

    if (!loaderContainer.classList.contains('loading')) {
      loaderContainer.classList.add('loading')
      return
    }

    loaderContainer.classList.remove('loading')
  }
}

export default morePost
